import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-server-provider',
  templateUrl: './server-provider.component.html',
  styleUrls: ['./server-provider.component.css']
})
export class ServerProviderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
